import { FC } from "react";

import { ROUTES } from "constants/routes";

import useForgotPassword from "./hooks/useForgotPassword";

import { Typography, useTheme } from "@mui/material";

import { Button } from "components/common/Button";
import { Link } from "components/common/Link";
import { Input } from "components/common/inputs/Input";
import { ConfirmationModal } from "components/common/modals/ConfirmationModal";

import {
  StyledForgotPassword,
  StyledForgotPasswordHeadings,
} from "styles/features/forgot-password";

const ForgotPassword: FC = () => {
  const theme = useTheme();

  const {
    email,
    loading,
    validFieldError,
    errorText,
    infoModalIsOpen,
    handleEmailChange,
    handleSubmit,
    checkFieldValidation,
    onInfoModalClose,
    handleRedirectToLogIn,
  } = useForgotPassword();

  return (
    <StyledForgotPassword>
      <StyledForgotPasswordHeadings>
        <Typography variant="h1" color={theme.palette.common.black}>
          Reset password
        </Typography>
        <Typography
          variant="bodyL"
          color={theme.palette.common.black}
          paragraph
          fontWeight={300}
          marginBottom={0}
        >
          Enter your email and we will send you a new temporary password
        </Typography>
      </StyledForgotPasswordHeadings>
      <Input
        value={email}
        placeholder="Enter your email"
        label="Email address"
        onChange={handleEmailChange}
        onBlur={checkFieldValidation(email)}
        errorText={errorText || "Please enter an email to reset password"}
        disabled={loading}
        error={validFieldError}
      />
      <Button
        className="forgot-password__btn"
        onClick={handleSubmit}
        disabled={loading}
        isLoading={loading}
      >
        Reset password
      </Button>
      <Typography
        variant="bodyL"
        color={theme.palette.customGrey.dark}
        paragraph
        gap="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        Don't have an account yet?
        <Link route={ROUTES.signUp} className="sign-in__forgot">
          Sign up
        </Link>
      </Typography>
      <ConfirmationModal
        title="Success!"
        text="We sent you an email with instructions on how to reset you password"
        submitBtnText="Log in"
        type="success"
        open={infoModalIsOpen}
        onClose={onInfoModalClose}
        onSubmit={handleRedirectToLogIn}
        onCancel={onInfoModalClose}
      />
    </StyledForgotPassword>
  );
};

export default ForgotPassword;
